import React from 'react';
import { useTranslation } from 'react-i18next';
import Tabs, { TabItem } from '@justpark/ui/src/components/Tabs';
import styles from '../../../static/scss/components/listingDetails/listingDetailsTabs.module.scss';

type Tab = 0 | 1 | 2;
type Props = {
  active: Tab,
  onChange: (Tab) => void,
  showAvailabilityTab: boolean
};

const ListingDetailsTabs = ({
  active,
  onChange,
  showAvailabilityTab
}: Props) => {
  const { t } = useTranslation();
  return (
    <Tabs
      evenSpacing
      active={active}
      onChange={onChange}
      cypress="listing-details-tabs"
      className={styles.tabs}
    >
      <TabItem cypress="listing-details-information-tab" className={styles.tab}>
        {t('listingDetails:informationTab', ' Information')}
      </TabItem>
      {showAvailabilityTab && (
        <TabItem
          cypress="listing-details-availability-tab"
          className={styles.tab}
        >
          {t('listingDetails:availabilityTab', ' Availability')}
        </TabItem>
      )}
      <TabItem cypress="listing-details-reviews-tab" className={styles.tab}>
        {t('listingDetails:reviewsTab', ' Reviews')}
      </TabItem>
    </Tabs>
  );
};

export default ListingDetailsTabs;
